import Icon from '../components/Icon.vue'

Icon.register({
  backspace: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M576 64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64h-370.8c-17 0-33.3-6.8-45.3-18.8l-150.6-150.6c-12.5-12.5-12.5-32.8 0-45.3l150.6-150.6c10.3-10.3 30.6-18.8 45.2-18.8h0 370.7zM491.3 318.1l-62.1-62.1 62.1-62.1c6.3-6.3 6.3-16.4 0-22.6l-22.6-22.6c-6.3-6.3-16.4-6.3-22.6 0l-62.1 62.1-62.1-62.1c-6.3-6.3-16.4-6.3-22.6 0l-22.6 22.6c-6.3 6.3-6.3 16.4 0 22.6l62.1 62.1-62.1 62.1c-6.3 6.3-6.3 16.4 0 22.6l22.6 22.6c6.3 6.3 16.4 6.3 22.6 0l62.1-62.1 62.1 62.1c6.3 6.3 16.4 6.3 22.6 0l22.6-22.6c6.3-6.3 6.3-16.4 0-22.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/backspace.js
// module id = 639
// module chunks = 0